// GA4 CTA click tracking: one document-level listener for the whole app.
// Any element with a data-cta attribute (or a click on something inside it) sends
// gtag('event', 'cta_click', { cta: <data-cta> }). The value naming and full list
// live in docs/tracking.md. gtag itself is loaded from public/gtag.js.
export default function initCtaTracking() {
  document.addEventListener('click', (event) => {
    const el = event.target && event.target.closest && event.target.closest('[data-cta]');
    if (!el || typeof window.gtag !== 'function') return;
    const cta = el.getAttribute('data-cta');
    if (!cta) return;
    // beacon keeps the hit alive when the click navigates away from the page.
    window.gtag('event', 'cta_click', { cta, transport_type: 'beacon' });
  }, true);
}
